import React from "react";

import "react-perfect-scrollbar/dist/css/styles.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import "assets/css/Scroll.css";

import ThemeComponent from "@core/theme/ThemeComponent";

import { useSettings } from "@core/hooks/useSettings";
import {
  SettingsConsumer,
  SettingsProvider,
} from "@core/context/settingsContext";
import MainPage from "@core/layouts/MainPage";

const App = () => {
  const { settings, saveSettings } = useSettings();

  return (
    <ThemeComponent settings={settings}>
      <SettingsProvider>
        <SettingsConsumer>
          {({ settings }) => {
            return <MainPage settings={settings} saveSettings={saveSettings} />;
          }}
        </SettingsConsumer>
      </SettingsProvider>
    </ThemeComponent>
  );
};

export default App;
